module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-200.fa68753c.ttf";